const urls = {
  MAIN_LOGIN_URL: '/',
  API_URL: '/api/test',
  API2_URL: '/api/devices',
  API_LISTS: '/api/lists',
  API_USERS: '/api/users',
  MAIN_LOGOUT_URL: '/login',
  MAIN_NEWPASSWORD_URL: '/profile/password',
};

export default urls;



// WEBPACK FOOTER //
// ./src/constants/urls.js